module.exports = __webpack_public_path__ + "img/icon-edit-2.426f6bda.svg";